import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared.module';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { DepartmentEditComponent } from './components/departments/edit/edit.component';
import { CapacityEditComponent } from './components/capacity/edit/edit.component';
import { CapacityComponent } from './pages/capacity/capacity.component';
import { DepartmentResolver } from './resolvers/department.resolver';
import { CapacityResolver } from './resolvers/capacity.resolver';
import { UploadsComponent } from './pages/uploads/uploads.component';
import { UploadsResolver } from './resolvers/uploads.resolver';
import { VisitsUploadsComponent } from './pages/visitsUploads/visitsUploads.component';
import { VisitsUploadsResolver } from './resolvers/visitsUpload.resolver';

const routes: Routes = [
  {
    path: 'uploads',
    component: UploadsComponent,
    data: { animation: 'isLeft' },
    resolve: {
      uploads: UploadsResolver,
    },
  },
  {
    path: 'visitsUploads',
    component: VisitsUploadsComponent,
    data: { animation: 'isLeft' },
    resolve: {
      uploads: VisitsUploadsResolver,
    },
  },
  {
    path: 'departments',
    component: DepartmentsComponent,
    data: { animation: 'isLeft' },
    resolve: {
      departaments: DepartmentResolver,
    },
  },
  {
    path: 'capacity',
    component: CapacityComponent,
    data: { animation: 'isLeft' },
    resolve: {
      capacities: CapacityResolver,
    },
  },
];

@NgModule({
  declarations: [UploadsComponent,VisitsUploadsComponent, DepartmentsComponent, CapacityComponent, DepartmentEditComponent, CapacityEditComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
  providers: [],
})
export class ParametrizationModule {}
